import styled from 'styled-components';

import { InputError as DefaultInputError } from 'components/UI/Inputs/InputError';

export const InputError = styled(DefaultInputError)`
	height: 1.6rem;
	min-height: 1.6rem;
`;
